import React from 'react';
import localStrings from "../../localStrings";
import GenericSparkDataSpark from "./GenericSparkDataSpark";
import {formatEurPriceAndRoundUtil} from "../../utils/currencyUtil";
import {useMediaQuery} from "@mui/material";
import DiscountIcon from "../../icons/untitled-ui/duocolor/dscount";

function DiscountsSpark() {
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    // Force graph mode for testing - change to md or sm for lower screen sizes
    const forceGraphMode = useMediaQuery((theme) => theme.breakpoints.up("md"));

    return (
        <GenericSparkDataSpark
            modeGraph={forceGraphMode}
            getterData={(data) => data?.totalDiscount}
            title={localStrings.totalDiscount}
            formatter={(value, lgUp) => {
                return formatEurPriceAndRoundUtil(value , lgUp);
            }}
            icon={<DiscountIcon />}
            backgroundColor={(theme) => theme.palette.mode === 'dark'
                ? 'neutral.800'
                : 'info.lightest'}
            invertComparison={true} // Discount decrease is good
        />
    )
}

export default DiscountsSpark